import { memo, useCallback, useState } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useDayStore } from '../../contexts/DayStore.jsx'
import TextToInput from '../../components/TextToInput/TextToInput.jsx'
import ColorPickerModal from '../../components/ColorPickerModal/ColorPickerModal'
import { RIGHT_CLICK } from '../../utils/constantes.js'

const DayViewGroup = memo(({ dayId, canEdit, interval, group, groupIndex, place_id }) => {
  const [isColorPickerOpen, setIsColorPickerOpen] = useState(false)
  const { updateGroupValue } = useDayStore(
    useShallow((state) => ({
      updateGroupValue: state.updateGroupValue,
    }))
  )

  const openColorPicker = (e) => {
    if (e.button === RIGHT_CLICK && canEdit) {
      setIsColorPickerOpen(true)
      e.preventDefault()
      return false
    }
  }

  const validate = useCallback(
    (nextValue) => {
      updateGroupValue(dayId, interval?._id, group?._id, 'text', nextValue)
    },
    [updateGroupValue, dayId, interval?._id, group?._id]
  )

  const updateColor = useCallback(
    (nextColor) => {
      updateGroupValue(dayId, interval?._id, group?._id, 'color', nextColor.hex)
    },
    [updateGroupValue, dayId, interval?._id, group?._id]
  )

  if (!group || group?.place_id !== place_id) {
    return <div key={groupIndex} className="sessionDayView" />
  }
  const sumPLayers = interval.sessions
    .filter((s) => s?.booking?.email === group.email && s?.place_id === place_id)
    .reduce((acc, curr) => acc + curr?.booking?.nbPlayers, 0)
  return (
    <div
      key={group._id}
      style={{ backgroundColor: group.color }}
      className="sessionDayView black"
      onContextMenu={openColorPicker}
    >
      <TextToInput
        forceDisabled={!canEdit}
        id={group._id}
        bgColor={group.color}
        className={`inputDayView black groupName`}
        initValue={group?.text}
        textValue={`${sumPLayers}p${group?.text?.length > 0 ? ` - ${group?.text}` : ''}`}
        onBlur={validate}
      />
      <ColorPickerModal
        setIsOpen={setIsColorPickerOpen}
        isOpen={isColorPickerOpen}
        color={group.color}
        onConfirm={updateColor}
      />
    </div>
  )
})
export default DayViewGroup
